// src/utils/dateUtils.js

// 1. Obtiene la fecha local de HOY en texto "YYYY-MM-DD"
export const getLocalDateString = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// Obtiene la hora local actual en formato HH:MM
export const getLocalTimeString = (date = new Date()) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

// src/utils/dateUtils.js



// 2. Convierte "YYYY-MM-DD" a formato legible ("5 ago") SIN alterar la zona horaria
export const formatDateLegible = (dateString) => {
    if (!dateString) return "Hoy";
    
    // Separamos el string manualmente para evitar que 'new Date' aplique desfases de zona horaria (UTC)
    const [year, month, day] = dateString.split("-").map(Number);
    
    // Creamos la fecha pasando año, mes (base 0) y día explícitos locales
    const localDate = new Date(year, month - 1, day);
    
    return localDate.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

